export const spacing = {
  xxsmall: "0.5em",
  xsmall: "1em",
  small: "1.5em",
  medium: "2em",
  large: "3em",
  xlarge: "4em",
  xxlarge: "5em"
} as const;
